/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState } from "react";
import clsx from "clsx";
import { MessageModel } from "../../../app/modules/apps/chat/core/_models";
import { useAuth } from "../../../app/modules/auth";
import { TICKET_MESSAGE_OWNER_CODE } from "../../../constants";
import timeAgo from "../../../utils/timeAgo";
import { postNewTicket } from "../../../app/modules/apps/chat/core/_requests";

const ChatInner: FC<{ messages: MessageModel[], ticket_id: number }> = ({ messages: _messages, ticket_id }) => {
  const { currentUser } = useAuth();
  const [message, setMessage] = useState<string>("");
  const [messages, setMessages] = useState<MessageModel[]>(_messages);

  const sendMessage = () => {
    const newMessage: MessageModel = {
      message,
      message_owner: TICKET_MESSAGE_OWNER_CODE.USER,
      created_time: new Date().toISOString(),
      user: { uuid: currentUser!.uuid, username: "", full_name: currentUser!.first_name + " " + currentUser!.last_name }
    };
    postNewTicket({ message, ticket: ticket_id }).then(() => {
      setMessages(prevState => [...prevState, newMessage]);
      setMessage("");
    }).catch(()=>{

    });

  };

  const onEnterPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.keyCode === 13 && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  return (
    <div
      className="card-body"
      id={"kt_chat_messenger_body"}
    >
      <div
        className={clsx("scroll-y me-n5 pe-5", "h-300px h-lg-auto")}
        data-kt-element="messages"
        data-kt-scroll="true"
        data-kt-scroll-activate="{default: false, lg: true}"
        data-kt-scroll-max-height="auto"
        data-kt-scroll-dependencies={"#kt_header, #kt_toolbar, #kt_footer, #kt_chat_messenger_header, #kt_chat_messenger_footer"}
        data-kt-scroll-wrappers={"#kt_content, #kt_chat_messenger_body"}
        data-kt-scroll-offset={"-2px"}
      >
        {messages.map((message, index) => {
          const userInfo = message.user;
          const state = message.message_owner === TICKET_MESSAGE_OWNER_CODE.OPERATOR ? "info" : "primary";
          const templateAttr = {};
          const contentClass = `d-flex justify-content-${
            message.message_owner === TICKET_MESSAGE_OWNER_CODE.OPERATOR ? "start" : "end"
          } mb-10`;
          return (
            <div
              key={`message${index}`}
              className={clsx("d-flex", contentClass, "mb-10")}
              {...templateAttr}
            >
              <div
                className={clsx(
                  "d-flex flex-column align-items",
                  `align-items-${message.message_owner === TICKET_MESSAGE_OWNER_CODE.OPERATOR ? "start" : "end"}`
                )}
              >
                <div className="d-flex align-items-center mb-2">
                  {message.message_owner === TICKET_MESSAGE_OWNER_CODE.OPERATOR ? (
                    <>
                      <div className="ms-3">
                        <a
                          href="#"
                          className="fs-5 fw-bolder text-gray-900 text-hover-primary me-1"
                        >
                          {userInfo.full_name}
                        </a>
                        <span className="text-muted fs-7 mb-1">{timeAgo(message.created_time)}</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="me-3">
                        <span className="text-muted fs-7 mb-1 d-inline-block">
                          {timeAgo(message.created_time)}
                        </span>
                        &nbsp;
                        <span
                          className="fs-5 fw-bolder text-gray-900 text-hover-primary ms-1"
                        >
                          شما
                        </span>
                      </div>
                    </>
                  )}
                </div>

                <div
                  className={clsx(
                    "p-5 rounded",
                    `bg-light-${state}`,
                    "text-dark fw-bold mw-lg-400px",
                    `text-${message.message_owner === TICKET_MESSAGE_OWNER_CODE.OPERATOR ? "start" : "end"}`
                  )}
                  data-kt-element="message-text"
                >
                  {message.message}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div
        className="card-footer pt-4"
        id={"kt_chat_messenger_footer"}
      >
        <textarea
          className="form-control form-control-flush mb-3"
          rows={1}
          data-kt-element="input"
          placeholder="متن پیام..."
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyDown={onEnterPress}
        />

        <div className="d-flex flex-stack">
          <button
            className="btn btn-primary"
            type="button"
            data-kt-element="send"
            onClick={sendMessage}
          >
            ارسال
          </button>
        </div>
      </div>
    </div>
  );
};

export { ChatInner };
